import { render, staticRenderFns } from "./InvoiceReminder.vue?vue&type=template&id=38b98ce4&scoped=true&"
import script from "./InvoiceReminder.vue?vue&type=script&lang=js&"
export * from "./InvoiceReminder.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceReminder.vue?vue&type=style&index=0&id=38b98ce4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b98ce4",
  null
  
)

export default component.exports